/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Logtail } from "@logtail/browser";
import { logOptions } from "./log-options.js";
import { cloudLog } from "./log-helpers.js";
// import { getLine, getStackFrames } from "cms/utils/log/stack";
// import { magentaBright, green,yellowBright, red } from "cms/utils/log/colors";
// import { transformSourceMap, initializeSourceMap } from "utils/log/sourcemaps"
// initializeSourceMap()

// const LoggerName = "[SimplicityAdminConsoleLogger]";

const CONFIG = {
    SourceToken: process.env.REACT_APP_LOG_SOURCE_TOKEN,
    enableConsole: process.env.REACT_APP_ENABLE_CONSOLE_LOG === "true" || false,
    enableApiHttp: process.env.REACT_APP_ENABLE_HTTP_LOG === "true" || false,
    enableSavePipelineLog: process.env.REACT_APP_ENABLE_SAVE_PIPELINE_LOG === "true" || false,
    enableWebpageLog: process.env.REACT_APP_ENABLE_WEBPAGE_LOG === "true" || false,
    localLoggingOnly: process.env.REACT_APP_LOG_SOURCE_TOKEN === undefined,
    disableCloud: process.env.REACT_APP_DISABLE_CLOUD_LOG === "true" || false,
    rebuildStack: process.env.REACT_APP_REBUILDSTACK === "true" || false,
};

const source_token = CONFIG.SourceToken;
const hasCloud = source_token;
const enableConsole = CONFIG.enableConsole;
// const rebuildStack = CONFIG.rebuildStack;
// const enableConsole = false
const disableCloud = CONFIG.disableCloud;
if (enableConsole) {
    // logOptions.sendLogsToConsoleOutput = true
}
if (disableCloud) {
    logOptions.sendLogsToBetterStack = false;
}

// Interceptor for the log
const developerLog = (log) => {
    if (log.level === "error") {
        const error = log?.error;
        // const stack = new Error().stack;
        const stack = error?.stack;
        const message = error?.message;
        const error_message = `${log.message} ${message} \n${stack}`;
        log.message = error_message;
        log = cloudLog(log, log.level);
    } else if (log.level === "warn") {
        log = cloudLog(log, log.level);
    } else {
        log = cloudLog(log, log.level);
    }
    return log;
};

const hasWebColor = (message) => {
    const isArray = Array.isArray(message);
    const isText = typeof message[0] === "string" ;
    const isColored = isArray && isText && message[0]?.startsWith("%c") || false;
    return isText && isColored;
};

const SimpliCityLogger = () => {
    let LogService;
    if (hasCloud) {
        LogService = new Logtail(source_token, logOptions);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        LogService.use(developerLog);
    }

    const debug = async function (...args) {
        if (enableConsole) {
            const first = args[0];
            const isArray = Array.isArray(first) && first.length > 1;
            const hasColor = hasWebColor(first);
            if (hasColor) {
                console.debug(...first);
            } else if (isArray) {
                console.debug(...first);
            } else {
                console.debug(first);

            }
        }
        if (hasCloud) {
            await LogService.debug(...args);
        }
    };

    const info = async function (...args) {
        if (enableConsole) {
            const first = args[0];
            const isArray = Array.isArray(first) && first.length > 1;
            const hasColor = hasWebColor(first);
            if (hasColor) {
                console.info(...first);
            } else if (isArray) {
                console.info(...first);
            } else {
                console.info(first);
            }
        }
        if (hasCloud) {
            await LogService.info(...args);
        }
    };

    const log = async function (...args) {
        if (enableConsole) {
            const first = args[0];
            const isArray = Array.isArray(first) && first.length > 1;
            const hasColor = hasWebColor(first);
            if (hasColor) {
                console.log(...first);
            } else if (isArray) {
                console.log(...first);
            } else {
                console.log(first);
            }
        }
        if (hasCloud) {
            await LogService.log(...args);
        }
    };

    const warn = async function (...args) {
        if (enableConsole) {
            const first = args[0];
            const isArray = Array.isArray(first) && first.length > 1;
            const hasColor = hasWebColor(first);
            if (hasColor) {
                console.warn(...first);
            } else if (isArray) {
                console.warn(...first);
            } else {
                console.warn(first);
            }
        }
        if (hasCloud) {
            await LogService.warn(...args);
        }
    };

    const error = async function (...args) {
        const first = args[0];
        const isArray = Array.isArray(first) && first.length > 1;
        const hasColor = hasWebColor(first);
        if (hasColor) {
            console.info("error has color");
            console.error(...first);
        } else if (isArray) {
            console.info("error is array");
            console.error(...first);
        } else {
            console.info("error reg");
            console.error(first);
        }
        if (hasCloud) {
            await LogService.error(...args);
        }
    };

    const flush = () => {};
    const use = () => {};
    return {
        debug,
        info,
        log,
        warn,
        error,
        flush,
        use,
    };
};
const logger = SimpliCityLogger();
export * from "./colors";
export { logger as Logger };

// eslint-disable-next-line no-unused-vars
// const rebuildArgs = async function (type, color, ...args) {
//     const data = args[1];
//     const stack = new Error().stack;
//     const frames = await getStackFrames(stack);
//     frames.splice(0, 1);
//     const file_line = await getLine(stack);
//     const firstArg = args[0];
//     const isString = typeof firstArg === "string";
//     const prefix = color(`[${type}]${file_line}`);
//     const message = isString
//         ? `${prefix} ${firstArg}`
//         : prefix;
//     args.splice(0, 1);
//     const argz = [];
//     argz.push(message);
//     if (data) {
//         argz.push(data);
//     }
//     argz.concat(...args);
//     if (rebuildStack) {
//         argz.push({ stack: { frames, trace: stack } });
//     }
//     return argz;
// };
